import axios from 'axios'
import config from '@/config'
import applyUrlTemplate from './applyUrlTemplate'
import applyDefaultParams from './applyDefaultParams'
import { applyCacheResuest, applyCacheResponse } from './cache'
import normalizeAxiosError, { SERVER_ERROR, TIMEOUT_ERROR, NETWORK_ERROR, CLIENT_ERROR } from './normalizeAxiosError'
import router from '@/router'
import { getPlatform } from '@/utils/utils'

const API_TIMEOUT = 30000 // 30s

const ncpApi = axios.create({
  baseURL: config.ncpApiBaseUrl,
  timeout: API_TIMEOUT,
  headers: {
    clientId: config.ncpClientId,
    Version: '1.0',
    platform: getPlatform()
  }
})

ncpApi.interceptors.request.use(applyCacheResuest)
ncpApi.interceptors.request.use(applyUrlTemplate)
ncpApi.interceptors.request.use(applyDefaultParams)

ncpApi.interceptors.response.use(applyCacheResponse)
ncpApi.interceptors.response.use(null, normalizeAxiosError)
ncpApi.interceptors.response.use(null, err => {
  if (err.code === TIMEOUT_ERROR || err.code === NETWORK_ERROR) {
    // soter.commit('error...', err)
  }
  if (err.code === SERVER_ERROR) {
    // soter.commit('error...', err)
    if (router.app._route.query.isDebug !== 'true') {
      router.push({ path: '/etc/dataerror' })
    }
  }
  if (err.code === CLIENT_ERROR) {
    const noalert = ['E0005', 'M0013', 'O0009', 'E9001', 'CL904', 'M0021']
    if (!noalert.some(item => item === err.data.code)) {
      console.log('1', err.data.message)
    } else {
      if (err.data.code === 'M0013') {
        ncpApi.defaults.headers.common['accessToken'] = ''
      }
      // router.replace({ path: '/' })
    }
  }
  return Promise.reject(err)
})

export default ncpApi
